var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMusic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6ZM14.6 14.4676V9.16037C14.6 8.82396 14.8105 8.5235 15.1266 8.40853L17.9266 7.39035C18.4484 7.20062 19 7.58702 19 8.14219V9.64563C19 9.9791 18.7931 10.2776 18.4809 10.3947L16.0596 11.3027C15.9034 11.3612 15.8 11.5105 15.8 11.6772V16.2C15.8 17.3046 14.7255 18.2 13.4 18.2C12.0745 18.2 11 17.3046 11 16.2C11 15.0955 12.0745 14.2 13.4 14.2C13.8371 14.2 14.247 14.2974 14.6 14.4676ZM12.6 12.2706V11.2779C11.8084 11.1059 10.9395 11 10 11C7.54671 11 5.5749 11.7222 4.20272 12.458C2.68053 13.2741 2 14.9703 2 16.6975C2 17.4169 2.58314 18 3.30248 18H9.45169C9.16712 17.4819 9 16.8794 9 16.2C9 13.9881 10.7713 12.5909 12.6 12.2706Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMusic);
export default __webpack_public_path__ + "static/media/user-music.c90ed6d5c52ace6442b03adf44ad5b9f.svg";
export { ForwardRef as ReactComponent };